module.exports = __webpack_public_path__ + "img/catalog (10).5cec43d4.jpg";